import React from "react";

import "./Solutions.scss";

export function Application(params) {
  let Card = (
    <div
      className={`card card-solution text-center h-100 py-4 px-3 ${params.className}`}
    >
      <div className="card-body">
        <div className="icon-container">
          {params.img && (
            <img
              src={require(`assets/images/icon/${params.img}`)}
              alt=""
              className="icon-img"
            />
          )}
        </div>

        <h5
          className="text-1 fw-normal"
          style={{
            marginTop: "0.625rem",
            ...params.styleHeading,
          }}
        >
          {params.name}
        </h5>
        <div
          className={
            params.className === "card-cta"
              ? "text-white d-flex justify-content-center"
              : "text-secondary"
          }
        >
          {params.children}
        </div>
      </div>
    </div>
  );

  return <div className="col-md-4 mb-3">{Card}</div>;
}

export default function Solutions() {
  return (
    <div
      id="solutions"
      style={{
        background:
          "linear-gradient(180deg, rgba(42, 122, 215, 0) 0%, rgba(42, 122, 215, 0.1) 100%)",
      }}
    >
      <div className="home-container">
        <div
          style={{
            textAlign: "center",
            paddingTop: "76px",
            paddingBottom: "58px",
          }}
        >
          <p
            style={{
              color: "#2A7AD7",
              fontSize: "32px",
              fontWeight: "600",
              margin: "0",
            }}
          >
            Our Solutions
          </p>

          <p
            style={{
              color: "#474747",
              fontSize: "20px",
              fontWeight: "500",
              margin: "0",
            }}
          >
            Build your own
          </p>
        </div>

        <div
          className="row justify-content-center solution-list"
          style={{
            paddingBottom: "80px",
          }}
        >
          <Application img={"gaming.svg"} name="Gaming" cs={true}>
            Build your own gaming platform and the world of NFT.
          </Application>

          <Application img={"finance.svg"} name="Finance" cs={true}>
            Build your own bank with the best defending distributed system.
          </Application>
          <Application img={"social.svg"} name="Social" cs={true}>
            Decentralized social media networks protect user privacy and enhance
            data security.
          </Application>
          <Application img={"insurance.svg"} name="Insurance" cs={true}>
            Insurance system with the blockchain and smart contracts to
            transform your business operation.
          </Application>
          <Application img={"exchange.svg"} name="Exchange" cs={true}>
            Decentralize exchange, the peer-2-peer marketplaces without
            intermediary or custodian.
          </Application>
          <Application
            img={"explorer.svg"}
            link="solutions/explorer"
            name="Explorer"
          >
            An absolute product for Hyper Block Explorer
          </Application>
        </div>
      </div>
    </div>
  );
}
